import InlineEditableHtml from './InlineEditableHtml'
import type { InlineEditableHtmlRef } from './InlineEditableHtml'

export type { InlineEditableHtmlRef }
export default InlineEditableHtml
